<template>
  <div>
    <Form class="i-form" @submit.native.prevent="preventSubmit" inline>
      <FormItem prop="city" label="省市：" :label-width="84">
        <Cascader :data="cityListWithAll" trigger="hover" @on-change="handleCityChange"></Cascader>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleBtn" :loading="loading">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="showCreateOrEditFeeModal('create')">新建城市费用</Button>
      </FormItem>
    </Form>
    <Content>
      <Table stripe :loading="loading" :columns="columns" :data="clothFeeList" size="large" style="width: 1302px;"></Table>
      <div style="margin: 10px 10px 30px 10px; overflow: hidden">
        <Page show-sizer 
          show-total
          placement="top" 
          :total="listCount" 
          :current="queryParams.page" 
          :page-size="queryParams.size"
          @on-page-size-change="changePageSize" 
          @on-change="changePage">
        </Page>
      </div>
    </Content>
    <!-- 新建城市费用弹窗 -->
    <Modal class="cloth-washing-fee"
      ref="createOrEditFeeModal"
      :loading="true"
      v-model="createOrEditFeeModal"
      :title="`${mode === 'create' ? '新建' : '修改'}城市费用`"
      width="650"
      :closable="false"
      ok-text="保存"
      @on-cancel="cancelCreateOrEditFee"
      @on-ok="confirmCreateOrEditFee">
      <Form ref="createOrEditFeeForm" :rules="checkValidate" :model="createOrEditFeeParam" inline>
        <FormItem label="省份：" prop="province" :label-width="84" v-show="mode === 'create'">
          <Select v-model="createOrEditFeeParam.province" style="width: 200px;" placeholder="请选择省份"
            @on-change="handleCreateProvinceChange">
            <Option v-for="province in provinceList" :key="province.id" :value="province.id + ' ' + province.custName" :label="province.custName">
              {{ province.custName }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="城市：" prop="city" :label-width="84" v-show="mode === 'create'">
          <Select v-model="createOrEditFeeParam.city" style="width: 200px;" placeholder="请选择城市"
            @on-change="handleCreateCityChange">
            <Option v-for="city in cityList" :key="city.id" :value="city.id + ' ' + city.custName" :label="city.custName">
              {{ city.custName }}
            </Option>
          </Select>
        </FormItem>
        <FormItem  label="省市：" prop="" :label-width="84" v-show="mode === 'edit'">
          <p style="font-size: 14px; color: #495060; line-height: 33px;">{{ createOrEditFeeParam.cityShow }}</p>
        </FormItem>
        <br>
        <FormItem :label-width="84">
          <Button type="primary" @click="addBedType">添加床数</Button>
        </FormItem>
        <br>
        <FormItem v-for="(item, index) in createOrEditFeeParam.bedType" :key="index" :label-width="25">
          <label class="ivu-form-item-label" style="width: 150px; display: inline-block;">床数：
            <Input type="text" v-model="item.bedNum" style="width:80px"></Input>
          </label>
          <label class="ivu-form-item-label" style="width: 150px; display: inline-block; margin-left: 10px;">巾类：
            <Input type="text" v-model="item.towelCharge" style="width:80px"></Input>
          </label>
          <label class="ivu-form-item-label" style="width: 150px; display: inline-block; margin-left: 10px;">床品：
            <Input type="text" v-model="item.bedspreadCharge" style="width:80px"></Input>
          </label>
          <Button type="error" style="margin: 10px 12px 10px 25px;" v-if="index !== 0" @click="deleteBedType(index)">删除</Button>
        </FormItem>
      </Form>
      <p class="err-msg" v-if="createOrEditFeeParam.errMsg">* {{ createOrEditFeeParam.errMsg }}</p>
    </Modal>
    <!-- 确认新建城市费用弹窗 -->
    <Modal ref="confirmModal" :loading="true" v-model="confirmModal" width="400"
      :closable="false" :ok-text="`确认${mode === 'start' ? '启用' : (mode === 'stop' ? '停用' : '保存')}`"
      @on-cancel="cancelCreateOrEditFee"
      @on-ok="(mode === 'create' || mode === 'edit') ? createOrEditFee() : (mode === 'start' || mode === 'stop') ? attachedChargingEditStatus() : ''">
      <p class="close-tips">{{ mode === 'start' ? '启用' : (mode === 'stop' ? '停用' : '保存') }}后立即生效！</p>
      <p class="close-tips">{{ mode === 'start' ? '新结束的清洁单将按标准计算费用！' : (mode === 'stop' ? '新结束的清洁单将不计算费用！' : '新结束的清洁单将按新标准计算费用！')}}</p>
      <p class="close-tips">确认{{ mode === 'start' ? '启用' : (mode === 'stop' ? '停用' : '保存') }}？</p>
    </Modal>
  </div>
</template>

<script>
/* eslint-disable */
import Utils from '@/utils'
import API from '@/api'

export default {
  data () {
    const checkSelect = {
      province: (rule, value, callback) => {
        if (!this.createOrEditFeeParam.province) {
          callback(new Error('请选择省份'))
        } else {
          callback()
        }
      },
      city: (rule, value, callback) => {
        if (!this.createOrEditFeeParam.city) {
          callback(new Error('请选择城市'))
        } else {
          callback()
        }
      }
    }
    return {
      loading: false, // 查询按钮loading
      cityListWithAll: [], // 省市列表（有全部选项）
      provinceList: [], // 省份列表
      cityList: [], // 城市列表
      queryParams: { // 传给接口的查询字段
        provinceId: '', // 省份
        cityId: '', // 城市
        page: 1, // 当前页数
        size: 10 // 每页显示的条数
      },
      clothFeeList: [], // 表格列表数据
      listCount: 0, // 分页
      mode: '', // 操作类型：create——新建 edit——修改 stop——停用 start——启用
      createOrEditFeeModal: false, // 是否显示新建城市费用弹窗
      confirmModal: false, // 是否显示确认新建城市费用弹窗
      currentOperateIndex: null, // 当前操作的行数
      columns: [
        {
          title: "省",
          key: "province",
          align: "center",
          width: 170
        },
        {
          title: "城市",
          key: "city",
          align: "center",
          width: 170
        },
        {
          title: "洗涤费标准",
          key: "chargingList",
          align: "center",
          width: 600,
          render: (h, params) => {
            let towelNode = []
            let bedspreadNode = []
            params.row.chargingList.map(item => {
              towelNode.push(h('b', {
                style: {
                  display: 'inline-block',
                  width: '40px'
                }
              }, item.bedNum + '床 '))
              towelNode.push(h('span', {
                style: {
                  display: 'inline-block',
                  marginRight: '12px',
                  width: '50px'
                }
              }, item.towelCharge))
              bedspreadNode.push(h('b', {
                style: {
                  display: 'inline-block',
                  width: '40px'
                }
              }, item.bedNum + '床 '))
              bedspreadNode.push(h('span', {
                style: {
                  display: 'inline-block',
                  marginRight: '12px',
                  width: '50px'
                }
              }, item.bedspreadCharge))
            })
            return h('div', {
              style: {
                padding: '5px 0'
              }
            }, [
              h('div', {
                style: {
                  display: 'flex',
                  marginBottom: '8px',
                  textAlign: 'left'
                }
              }, [
                h('b', {
                  style: {
                    display: 'inline-block',
                    width: '45px'
                  }
                }, '巾类：'), h('p', {
                  style: {
                    flex: '1',
                    margin: '0'
                  }
                }, towelNode)
              ]),
              h('div', {
                style: {
                  display: 'flex',
                  textAlign: 'left'
                }
              }, [
                h('b', {
                  style: {
                    display: 'inline-block',
                    width: '45px'
                  }
                }, '床品：'), h('p', {
                  style: {
                    flex: '1',
                    margin: '0'
                  }
                }, bedspreadNode)
              ])
            ])
          }
        },
        {
          title: "状态",
          key: "status",
          align: "center",
          width: 100,
          render:(h, params) => {
            return h('div', {}, params.row.status ? '启用' : '停用')
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 260,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.showCreateOrEditFeeModal('edit', params.row)
                    }
                  }
                },
                '修改'
              ),
              h('Button', {
                  props: {
                    type: params.row.status ? 'error' : 'success',
                    size: 'small'
                  },
                  style: {
                    marginLeft: '10px'
                  },
                  on: {
                    click: () => {
                      this.showConfirmModal(params.index, params.row.status ? 'stop' : 'start')
                    }
                  }
                },
                params.row.status ? '停用' : '启用'
              )
            ])
          }
        },
      ],
      createOrEditFeeParam: {
        province: '',
        city: '',
        bedType: [
          {
            bedNum: null,
            towelCharge: null,
            bedspreadCharge: null
          }
        ],
        errMsg: ''
      },
      checkValidate: {
        city: [
          {required: true, validator: checkSelect.city, trigger: 'change' }
        ],
        province: [
          {required: true, validator: checkSelect.province, trigger: 'change' }
        ]
      }
    }
  },

  created () {
		this.token = Utils.findFromLocalStorage('vue-token');
		this.username = Utils.findFromLocalStorage('vue-username');
		this.env = Utils.findFromLocalStorage('env', 'dev');
    this.AuthorToken = Utils.findFromLocalStorage('Author-token');
    this.headerENV = Utils.aliHeaderEnv(this.env)
    this.aliyunTestENV = process.env.NODE_ENV === 'development' ? 'dev' : 'qa'
	},

  mounted () {
    this.$Notice.config({
			top: 150
    })
    if (!Utils.hasPermission('xbCleanAttachedCharging_list')) {
      this.$Notice.error( {
        title: '无权限操作'
      })
      return
    }
    this.getCityList()
    this.getClothFee()
  },

  methods: {
    // 获取省市列表
    async getCityList () {
      if (!Utils.hasPermission('xbCleanAttachedCharging_list')) {
        this.$Notice.error( {
          title: '无权限操作'
        })
        return
      }
      let cityList = (await API.omsAPI[this.env].clientServer.attachedChargingCities({}, {
        'x-ca-stage': this.headerENV,
        'Authorization': this.AuthorToken,
        // 'Right': this.token,
        // 'group': this.aliyunTestENV
      })).data
      if (cityList.retCode) {
        this.$Notice.error( {
          title: cityList.msg,
          desc: "获取城市列表失败"
        })
      }
      this.transformCityData(cityList.data, 'province')
    },

    // 获取所有省份
    async queryProvinces () {
      let provinceList = (await API.omsAPI[this.env].common.queryProvinces()).data
      if (provinceList.retCode) {
        this.$Notice.error( {
          title: provinceList.msg,
          desc: "获取所有省份失败"
        })
      }
      this.provinceList = provinceList.province
    },

    // 获取省份下的所有城市
    async queryCities (provinceId) {
      let cityList = (await API.omsAPI[this.env].common.queryCities(provinceId)).data
      if (cityList.retCode) {
        this.$Notice.error( {
          title: cityList.msg,
          desc: "获取城市失败"
        })
      }
      this.cityList = cityList.city
    },

    // 处理城市数据
    transformCityData (cities, mode) {
      cities.map(item => {
        item.value = item.provinceId || item.cityId
        item.label = item.province || item.cityName
        if (item.cityList) {
          item.children = item.cityList
          this.transformCityData(item.cityList, 'city')
        } else if (mode === 'province') {
          item.children = {
            value: '00',
            label: '全部'
          }
        }
      })
      if (mode === 'city') {
        cities.unshift({
          value: '00',
          label: '全部市'
        })
      }
      this.cityListWithAll = cities
    },

    // 省市选择
    handleCityChange (value) {
      this.queryParams.provinceId = value[0]
      this.queryParams.cityId = value[1] === '00' ? '' : value[1]
    },

    // 新建城市费用的省市选择
    handleCreateProvinceChange (value) {
      if (value) {
        this.createOrEditFeeParam.cityShow = value.split(' ')[1]
        this.createOrEditFeeParam.city = ''
        this.queryCities(value.split(' ')[0])
      }
    },

    handleCreateCityChange (value) {
      if (value) this.createOrEditFeeParam.cityShow += (' ' + value.split(' ')[1])
    },

    // 显示（隐藏）新建（修改）城市费用弹窗
    showCreateOrEditFeeModal (mode, data) {
      if ((mode === 'create' && !Utils.hasPermission('xbCleanAttachedCharging_batchSave')) || (mode === 'edit' && !Utils.hasPermission('xbCleanAttachedCharging_edit'))) {
        this.$Notice.error( {
          title: "无权限操作"
        })
        return
      }
      let tmpList = []
      if (data) {
        tmpList = data.chargingList.map(o => {return Object.assign({}, o)})
      }
      this.mode = mode
      this.createOrEditFeeModal = true
      if (mode === 'create') {
        this.queryProvinces()
        this.cityList = []
        this.createOrEditFeeParam.province = ''
        this.createOrEditFeeParam.city = ''
        this.createOrEditFeeParam.cityShow = ''
        this.createOrEditFeeParam.errMsg = ''
        this.createOrEditFeeParam.bedType = [
          {
            bedNum: null,
            towelCharge: null,
            bedspreadCharge: null
          }
        ]
      } else if (mode === 'edit') {
        this.createOrEditFeeParam.province = data.provinceId
        this.createOrEditFeeParam.city = data.cityId
        this.createOrEditFeeParam.cityShow = `${data.province} ${data.city}`
        this.createOrEditFeeParam.errMsg = ''
        this.createOrEditFeeParam.bedType = tmpList
      }
    },

    // 新建城市费用取消按钮
    cancelCreateOrEditFee() {
      // debugger
      if (this.mode === 'create') {
        this.$refs.createOrEditFeeForm.resetFields()
        this.provinceList = []
      } else if (this.mode === 'edit') {
        this.createOrEditFeeParam.province = ''
        this.createOrEditFeeParam.city = ''
      }
      this.createOrEditFeeParam.cityShow = ''
      this.createOrEditFeeParam.bedType = [
        {
          bedNum: null,
          towelCharge: null,
          bedspreadCharge: null
        }
      ]
    },

    // 新建城市费用确认弹窗
    confirmCreateOrEditFee () {
      this.$refs.createOrEditFeeModal.buttonLoading = false;
      if(!this.validateResource('createOrEditFeeForm')) {
        return
      }
      let allParamsValidated = true
      let count = 0
      this.createOrEditFeeParam.bedType.map(item => {
        this.createOrEditFeeParam.bedType.map(innerItem => {
          if (item.bedNum * 1 === innerItem.bedNum * 1) {
            count = count + 1
          }
        })
        if (!item.bedNum || !(/^\+?[1-9][0-9]?$/.test(item.bedNum))) {
          this.createOrEditFeeParam.errMsg = '请正确输入床数！'
          allParamsValidated = false
        } else if (!item.towelCharge || !(/^(([1-9][0-9]{0,2})|(([0]\.\d{1,2}|[1-9][0-9]{0,2}\.\d{1,2})))$/.test(item.towelCharge))) {
          this.createOrEditFeeParam.errMsg = '请正确输入巾类费用！（价格最多保留两位小数）'
          allParamsValidated = false
        } else if (!item.bedspreadCharge || !(/^(([1-9][0-9]{0,2})|(([0]\.\d{1,2}|[1-9][0-9]{0,2}\.\d{1,2})))$/.test(item.bedspreadCharge))) {
          this.createOrEditFeeParam.errMsg = '请正确输入床品费用！（价格最多保留两位小数）'
          allParamsValidated = false
        }
      })
      if (count > this.createOrEditFeeParam.bedType.length) {
        this.createOrEditFeeParam.errMsg = '床数不可重复设置，请检查！'
        return
      }
      if (!allParamsValidated) {
        return
      }
      this.$refs.createOrEditFeeModal.buttonLoading = true;
      if (this.mode === 'edit') {
        this.confirmModal = true
        this.createOrEditFeeModal = false
      } else if (this.mode === 'create') {
        this.createOrEditFee()
      }
    },

    // 检查必填项是否为空
    validateResource(name) {
      let _res
      this.$refs[name].validate((valid) => {
        _res = valid ? true : false
      })
      return _res
    },

    // 添加床数
    addBedType () {
      let tmp = {}
      tmp = Object.assign({}, this.createOrEditFeeParam)
      tmp.bedType.push({
        bedNum: null,
        towelCharge: null,
        bedspreadCharge: null
      })
      this.createOrEditFeeParam = tmp
    },

    // 删除床数
    deleteBedType (index) {
      let tmp = {}
      tmp = Object.assign({}, this.createOrEditFeeParam)
      tmp.bedType.splice(index, 1)
      this.createOrEditFeeParam = tmp
    },

    // 新建（修改）城市费用
    async createOrEditFee () {
      if (this.mode === 'edit') {
        this.$refs.confirmModal.buttonLoading = true
      }
      let params = {
        provinceName: this.createOrEditFeeParam.cityShow.split(' ')[0],
        cityName: this.createOrEditFeeParam.cityShow.split(' ')[1],
        provinceId: (typeof(this.createOrEditFeeParam.province) === 'string') ?
          this.createOrEditFeeParam.province.split(' ')[0] * 1 : this.createOrEditFeeParam.province,
        cityId: (typeof(this.createOrEditFeeParam.city) === 'string') ?
          this.createOrEditFeeParam.city.split(' ')[0] * 1 : this.createOrEditFeeParam.city,
        chargingList: JSON.stringify(this.createOrEditFeeParam.bedType),
        createName: this.username
      }
      // console.info(params)
      let res
      if (this.mode === 'create') {
        res = (await API.omsAPI[this.env].clientServer.attachedChargingCreate(params, {
          'x-ca-stage': this.headerENV,
          'Authorization': this.AuthorToken,
          // 'Right': this.token,
          // 'group': this.aliyunTestENV
        })).data
      } else if (this.mode === 'edit') {
        res = (await API.omsAPI[this.env].clientServer.attachedChargingEdit(params, {
          'x-ca-stage': this.headerENV,
          'Authorization': this.AuthorToken,
          // 'Right': this.token,
          // 'group': this.aliyunTestENV
        })).data
      }
      // console.log(res)
      if (res.retCode || res.code !== '0000') {
        this.$refs.confirmModal.buttonLoading = false
        this.cancelCreateOrEditFee()
        if (this.mode === 'edit') {
          this.confirmModal = false
        } else if (this.mode === 'create') {
          this.createOrEditFeeModal = false
        }
        this.$Notice.error( {
          title: '错误',
          desc: `${this.mode === 'create' ? '新建' : '修改'}城市费用失败：${res.msg}`
        })
        return
      }
      this.cancelCreateOrEditFee()
      if (this.mode === 'edit') {
        this.confirmModal = false
      } else if (this.mode === 'create') {
        this.createOrEditFeeModal = false
      }
      this.getCityList()
      this.getClothFee()
    },

    // 防止表单自动提交
    preventSubmit () {
      return false
    },

    // 查询按钮操作
    handleBtn () {
      this.queryParams.page = 1
      this.getClothFee()
    },

    // 查询布草洗涤费
    async getClothFee () {
      if (!Utils.hasPermission('xbCleanAttachedCharging_list')) {
        this.$Notice.error( {
          title: '无权限操作'
        })
        return
      }
      this.loading = true
      let params = this.queryParams
      console.info(params)
      let res = (await API.omsAPI[this.env].clientServer.attachedChargingList(params, {
        'x-ca-stage': this.headerENV,
        'Authorization': this.AuthorToken,
        // 'Right': this.token,
        // 'group': this.aliyunTestENV
      })).data
      if (res.retCode) {
        this.loading = false
        this.$Notice.error( {
          title: res.msg,
          desc: "获取布草洗涤费失败"
        })
        return
      }
      this.clothFeeList = res.data.content
      this.listCount = res.data.totalCount
      this.loading = false
    },

    // 停用（启用）显示确认弹窗
    showConfirmModal (index, mode) {
      if (!Utils.hasPermission('xbCleanAttachedCharging_editStatus')) {
        this.$Notice.error( {
          title: "无权限操作"
        })
        return
      }
      this.currentOperateIndex = index
      this.mode = mode
      this.confirmModal = true
    },

    // 清洁单附属费用设置-修改状态
    async attachedChargingEditStatus () {
      let params = {
        cityId: this.clothFeeList[this.currentOperateIndex].cityId,
        status: this.clothFeeList[this.currentOperateIndex].status ? 0 : 1,
        updateName: this.username
      }
      // console.dir(params)
      let res = (await API.omsAPI[this.env].clientServer.attachedChargingEditStatus(params, {
        'x-ca-stage': this.headerENV,
        'Authorization': this.AuthorToken,
        // 'Right': this.token,
        // 'group': this.aliyunTestENV
      })).data
      if (res.retCode || res.code !== '0000') {
        this.$refs.confirmModal.buttonLoading = false
        this.confirmModal = false
        this.$Notice.error( {
          title: '错误',
          desc: `修改城市费用状态失败：${res.msg}`
        })
        return
      }
      this.$refs.confirmModal.buttonLoading = false
      this.confirmModal = false
      this.getClothFee()
    },

    // 分页
    changePageSize (size) {
      this.queryParams.page = 1
      this.queryParams.size = size
      this.getClothFee()
    },

    changePage (pageIndex) {
      this.queryParams.page = pageIndex
      this.getClothFee()
    }
  }
}
</script>

<style lang="scss">
.err-msg {
  margin-left: 25px;
  color: #ed3f14;
  font-size: 12px;
  font-family: SimSun;
}
.close-tips {
  color: #495060;
  font-size: 14px;
  text-align: center;
  margin: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/cleaner/additional-fee/cloth-washing-fee.vue